import { env } from 'config/environment'
import { i18n } from 'i18n'
import { Footer } from 'type/Product'

function fixFooter(raw: Footer | boolean | null | undefined): Footer {
  if (raw == null || raw === true) return {}
  if (raw === false) return { on: false }
  return raw
}

function getTitle() {
  const atelier = env.domain === 'atelier'
  if (atelier) return 'Atelier Digital AI'
  const dresscode = env.domain === 'dresscode'
  return dresscode ? 'DRESSCODE AI' : 'SHOWOFF'
}

function getLink() {
  const atelier = env.domain === 'atelier'
  if (atelier) return 'https://atelierdigitalai.com/'
  const dresscode = env.domain === 'dresscode'
  return dresscode ? 'https://www.dresscode.ai/' : 'https://www.showoff.app/'

}

export class PoweredOptions {
  readonly on: boolean
  private readonly _powered: string | undefined
  private readonly _by: string | undefined
  private readonly _url: string | undefined

  static fromFooter(footer: Footer | boolean | null | undefined): PoweredOptions {
    footer = fixFooter(footer)
    return new PoweredOptions(footer)
  }

  private constructor(json: Footer) {
    const { on, custom, powered, by, url } = json
    this.on = on !== false
    if (custom) {
      this._powered = powered?.trim() || undefined
      this._by = by?.trim() || undefined
      this._url = url?.trim() || undefined
    }
  }

  get powered(): string {
    return this._powered || i18n('PoweredBy')
  }

  get by(): string {
    return this._by || getTitle()
  }

  get url(): string {
    return this._url || getLink()
  }
}
